<template>
  <div class="page-container">
    <div class="sidebar">
      <Sidebar />
    </div>
    <div class="content-wrapper">
      <Categories />
    </div>
  </div>
</template>

<script>
import Categories from '@/components/Categories.vue'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'CategoriesView',
  components: {
    Categories,
    Sidebar
  }
}
</script>
